import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-commission-details-modal',
  templateUrl: './commission-details-modal.component.html',
  styleUrls: ['./commission-details-modal.component.scss'],
})
export class CommissionDetailsModalComponent {
  constructor(
    private dialogRef: MatDialogRef<CommissionDetailsModalComponent>
  ) {}

  close() {
    this.dialogRef.close();
  }
}
